export const getPassengerInitials = (passengerName = "") =>
  passengerName
    .split(" ")
    .map((partOfTheName) => partOfTheName[0])
    .slice(0, 2)
    .join("");
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";